// extracted by mini-css-extract-plugin
module.exports = {"AnswerList":"AnswerList_AnswerList__3G45M"};